import { IPickerModel } from '@rhybus/api'
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'

import { mpfAuthCrudHttp } from '../../../assets/ts/api/mpf-auth-crud-http'
import { mpfWhoHttp } from '../../../assets/ts/api/mpf-who-http'
import { twoDigits } from '../../../assets/ts/formatting/formatting'
import Buttons from '../../../components/buttons/buttons'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import usePascodeMetadata from '../../../hooks/use-pascode-metadata'
import useUsers from '../../../hooks/use-users'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { RoleContext } from '../../../store/role-context-provider'
import {
  ALL_SELECT_LABEL,
  MAX_LENGTHS,
} from '../../../utils/constants/global-constants'
import { NORESULT } from '../../../utils/constants/rhybus-config'
import CustomSelect from '../../../utils/controls/custom-select'
import InputText from '../../../utils/controls/input-text'
import { userrolesdrodown } from '../../../utils/controls/select-options-data'
import AddRemoveUser from './add-remove-user'

const UserManagement = (props: any) => {
  const { fetchUsers, users } = useUsers({})
  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })
  const { components } = useContext(MetadataContext)
  const roleContext = useContext(RoleContext)

  const [showPageOverlay, setShowPageOverlay] = useState(true)

  const visibleSquadrons: {
    MPFOwner: string[]
    SectionOwner: any[]
  } = {
    MPFOwner: [],
    SectionOwner: [],
  }

  const filterOptions: any = {
    assignedComponents: [],
    majcom: [],
  }
  roleContext.userGroups.map((group: string) => {
    const splitGroup: string[] = group.split('-')
    let assignedComponentGroup = -1
    if (group.includes('RegAF')) {
      assignedComponentGroup = 143
    } else if (group.includes('ANG')) {
      assignedComponentGroup = 145
    } else if (group.includes('AFRC')) {
      assignedComponentGroup = 144
    }

    const squadronPascodes = pascodeMetadata.filter(
      (pascode: any) =>{
        return (
        pascode.ServicingOrganization === `${splitGroup[0].split(' ')[0]} MPF` ||
        group.includes('CP Owner') ||
        group === 'Admin' ||
        assignedComponentGroup === pascode.AssignedComponentCode ||
        (group.includes('Owner') && pascode.ServicingMAJCOM === group.split(' ')[0]))}
    )

    squadronPascodes.forEach((pascode: any) => {
      if (!filterOptions.assignedComponents.includes(pascode.AssignedComponentCode)) {
        filterOptions.assignedComponents.push(pascode.AssignedComponentCode)
      }

      if (!filterOptions.majcom.includes(pascode.ServicingMAJCOM)) {
        filterOptions.majcom.push(pascode.ServicingMAJCOM)
      }
    })

    if (splitGroup[2] === 'MPF Owner') {
      visibleSquadrons.MPFOwner.push(splitGroup[0])
    } else if (splitGroup[3] === 'Owner') {
      visibleSquadrons.SectionOwner.push({
        section: splitGroup[2],
        squadron: splitGroup[0],
      })
    }
  })

  const [inputValues, setInputValues] = useState<any>({
    assignedComponentCode: -1,
    assignedComponentShortName: '',
    majcom: '',
    section: '',
    squadron: '',
  })
  const [filteredRoles, setFilteredRoles] = useState<string[]>([])
  const [rolesToAdd, setRolesToAdd] = useState<string[]>([])
  const [formattedUsers, setFormattedUsers] = useState({})
  const [filteredUsers, setFilteredUsers] = useState({})
  const [peopleDropdownNames, setPeopleDropdownNames] = useState<string[]>([])
  const [peopleExpand, setPeopleExpand] = useState<Array<IPickerModel>>([])
  const [searchedUserToggle, setSearchedUserToggle] = useState<boolean>(false)
  const [searchError, setSearchError] = useState<boolean>(false)
  const [selectedValue, setSelectedValue] = useState<any>({
    id: '',
    mailId: '',
    roles: [],
    title: '',
  })
  const [searchedUser, setSearchedUser] = useState('')

  const [btnActionshowhide, setActionbtnshowhide] = useState({
    removeuser: false,
    usersearch: false,
  })
  const [showActionPopups, setShowActionPopups] = useState({
    removeuser: false,
    usersearch: false,
  })
  const [userRoleOptions, setUserRoleOptions] = useState(userrolesdrodown)
  const [assignedComponentOptions, setAssignedComponentOptions] = useState([
    ...(components ?? []).map((c) => ({
      label: c.Component,
      obj: c,
      value: c.ComponentCode,
    })),
  ])

  const [squadronOptions, setSquadronOptions] = useState([])

  const [majcomOptions, setMajcomOptions] = useState<any[]>([])

  useEffect(() => {
    let sectionRoles: any[] = []
    let filterComponentOpt: any[] = []
    if (roleContext.isCPOwner || roleContext.isSiteAdmin) {
      filterComponentOpt.unshift({ label: 'CP Owners', value: -1 })
    }
    if (components.length > 0 && pascodeMetadata.length > 0) {
      filterComponentOpt = assignedComponentOptions.filter((opt) =>
        filterOptions?.assignedComponents?.includes(opt.value)
      )
      if (roleContext.isCPOwner || roleContext.isSiteAdmin) {
        filterComponentOpt.unshift({ label: 'CP Owners', value: -1 })
      }

      const options = [
        ...pascodeMetadata
          .filter(
            (pascodeEntry: any) =>
              pascodeEntry.AssignedComponentCode === filterComponentOpt[0].value &&
              pascodeEntry.ServicingMAJCOM !== null
          )
          .map((pascodeEntry: any) => ({
            label: pascodeEntry.ServicingMAJCOM,
            value: pascodeEntry.ServicingMAJCOM,
          })),
      ]

      if (roleContext.isSectionOwner) {
        const userRoles: any = []
        visibleSquadrons.SectionOwner.forEach((section: any) => {
          userRoles.push(section.section)
        })
        sectionRoles = userrolesdrodown.filter((section) => userRoles.includes(section.value))
        setUserRoleOptions(sectionRoles)
      }


      setAssignedComponentOptions(filterComponentOpt)
      const filteredMajcomOpt = options.filter((opt) => {
        return opt.label !== null && filterOptions?.majcom?.includes(opt.label)
      })

      const formattedMajcomOpts: any[] = [
        ...Object.values(
          filteredMajcomOpt.reduce(
            (acc, obj) => ({
              ...acc,
              [obj.value]: obj,
            }),
            {}
          )
        ),
      ]

      if (formattedMajcomOpts.length > 1) {
        formattedMajcomOpts.unshift({ label: ALL_SELECT_LABEL, value: '' })
      }

      setMajcomOptions(formattedMajcomOpts)
      setInputValues({
        ...inputValues,
        assignedComponentCode: filterComponentOpt[0]?.value,
        assignedComponentShortName: filterComponentOpt[0]?.obj?.AbbrValue,
        majcom: filteredMajcomOpt[0]?.value,
        section: roleContext.isSectionOwner ? sectionRoles[0].value : '',
        squadron: '',
      })
      setShowPageOverlay(false)
    }
  }, [pascodeMetadata, components])

  useEffect(() => {
    if (inputValues.assignComponentCode !== -1) {

      const formattedUserRoleOptions = [...userRoleOptions]

      if (
        (roleContext.isAssignedComponentOwner ||
          roleContext.isCPOwner ||
          roleContext.isSiteAdmin) && formattedUserRoleOptions.findIndex((userRole) =>
            userRole.label === 'MAJCOM Owners'
          ) === -1
      ) {
          formattedUserRoleOptions.unshift({
            label: 'Component Owner',
            value: 'Component Owner',
          })
      }
      if ((roleContext.isMAJCOMOwner ||
        roleContext.isAssignedComponentOwner ||
          roleContext.isCPOwner ||
          roleContext.isSiteAdmin) && formattedUserRoleOptions.findIndex((userRole) =>
            userRole.label === 'MAJCOM Owners'
          ) === -1) {
        formattedUserRoleOptions.unshift({
          label: 'MAJCOM Owners',
          value: 'Owner',
        })
      }
      if (formattedUserRoleOptions.length > 1 &&
        formattedUserRoleOptions.findIndex((userRole) =>
          userRole.label === ALL_SELECT_LABEL
        ) === -1)
        formattedUserRoleOptions.unshift({ label: ALL_SELECT_LABEL, value: '' })
      setUserRoleOptions(formattedUserRoleOptions)
    }
  }, [inputValues])

  useEffect(() => {
    formatUsers(users)
  }, [users])

  useEffect(() => {
    const filteredUserObj = {}
    for (const attr in formattedUsers) {
      filteredUserObj[attr] = formattedUsers[attr]
    }

    const squadron = pascodeMetadata.filter(
      (pascode: any) =>
        pascode.AssignedComponentCode === inputValues.assignedComponentCode &&
        pascode.ServicingMAJCOM === inputValues.majcom
    )[0]?.ServicingOrganization
    if (Object.keys(filteredUserObj).length > 0 && squadron) {
      Object.keys(filteredUserObj).filter((role) => {
        const splitRole = role.split('-')

        if (
          splitRole[3] !== 'CSS' &&
          inputValues.userRole?.toLowerCase() !== splitRole[2]?.toLowerCase() &&
          squadron?.split(' ')[0]?.toLowerCase() !== splitRole[0].split(' ')[0]?.toLowerCase() &&
          role.includes('Owners') &&
          role.toLowerCase() !== inputValues.userRole.toLowerCase()
        ) {
          delete filteredUserObj[role]
        }
      })
    }
    setFilteredUsers(filteredUserObj)
    setFilteredRoles([])
    mpfAuthCrudHttp()
      .GetRoles()
      .then((serverRoles: any) => {
        let filteredServerRoles: any[] = []
        const currentSquadrons: any[] = []

        pascodeMetadata.forEach((pascode) => {
          if (pascode.AssignedComponentCode === inputValues.assignedComponentCode) {
            if (pascode.ServicingMAJCOM === inputValues.majcom || inputValues.majcom === '') {
              if (!currentSquadrons.includes(pascode.ServicingOrganization))
                currentSquadrons.push(pascode.ServicingOrganization)
            }
          }
        })

        const formattedSquadronOptions: any = currentSquadrons
          .filter((squadron) => {
            const formattedSquadron = squadron.split(' ')[0] + ' FSS'
            return serverRoles.some((role) => role.name.includes(formattedSquadron))
          })
          .map((squad) => ({ label: squad, value: squad }))

        if (formattedSquadronOptions.length > 1)
          formattedSquadronOptions.unshift({ label: ALL_SELECT_LABEL, value: '' })

        setSquadronOptions(formattedSquadronOptions)
        if (inputValues.assignedComponentCode === -1) {
          filteredServerRoles = serverRoles
            .filter((role) => role.name.includes('CP Owner'))
            .map((role) => role.name)
        } else {
          switch (inputValues.section) {
            case 'Component Owner':
              filteredServerRoles = serverRoles
                .filter((role) => {
                  return (
                    assignedComponentOptions.some((ac) => role.name.includes(ac?.obj?.AbbrValue) && ac?.obj?.AbbrValue === inputValues.assignedComponentShortName) && role.name.includes('Owner') && !role.name.includes('FSS-MPF')
                  )
                })
                .map((role) => role.name)
              break
            case 'MPF Owner':
              filteredServerRoles = serverRoles
                .filter((role) => {
                  const formattedSquadron = !isNaN(role.name.split(' ')[0]) ? role.name.split(' ')[0] + ' MPF' : role.name.split(' ')[0]
                  return (
                    currentSquadrons.includes(formattedSquadron) && role.name.includes('MPF Owner')
                  )
                })
                .map((role) => role.name)
              break
            case 'Leadership':
              filteredServerRoles = serverRoles
                .filter((role) => {
                  const formattedSquadron = role.name.split(' ')[0] + ' MPF'
                  return (
                    currentSquadrons.includes(formattedSquadron) && role.name.includes('Leadership')
                  )
                })
                .map((role) => role.name)
              break
            case 'Owner':
              filteredServerRoles = serverRoles
                .filter((role) => {
                  return (
                    role.name.includes('Owner') &&
                    userRoleOptions.findIndex((userRole) =>
                    (role.owners[0].includes(userRole.value) &&
                      role.owners[0].includes(inputValues.assignedComponentShortName) && (role.name.includes(inputValues.majcom) || inputValues.majcom === '') &&
                      !role.name.includes('FSS-MPF')
                    )
                    ) !== -1
                  )
                })
                .map((role) => role.name)
              break
            case 'CSS':
              if (pascodeMetadata) {
                const pascodes = pascodeMetadata
                  .filter((pascode) => {
                    return currentSquadrons.includes(pascode.ServicingOrganization)
                  })
                  .map((pascode) => pascode.PASCODE.slice(pascode.PASCODE.length - 4))

                filteredServerRoles = serverRoles
                  .filter((role) => {
                    return pascodes.some((pascode) => role.name.includes(pascode))
                  })
                  .map((role) => role.name)
              }
              break
            case '':
              if (inputValues.assignedComponentCode !== -1) {
                filteredServerRoles = serverRoles
                  .filter((role) => {
                    let canSeeRole = true
                    let canSeeOwners = false
                    const formattedSquadron = role.name.split(' ')[0] + ' MPF'

                    if (roleContext.isMPFOwner) {
                      if (
                        role.name.includes('Technician') ||
                        role.name.includes('Section Chief') ||
                        role.name.includes('Supervisor')
                      ) {
                        canSeeRole = false
                      }
                    } else if (roleContext.isCPOwner || roleContext.isSiteAdmin || 
                      roleContext.isAFRCOwner || roleContext.isANGOwner) {
                      canSeeOwners = role.name.includes('Owner') &&
                        (role.name.includes(inputValues.majcom) || inputValues.majcom === '' || roleContext.isAFRCOwner || roleContext.isANGOwner ||
                        ((roleContext.isCPOwner || roleContext.isSiteAdmin) && 
                        (inputValues.assignedComponentCode === 144 ||
                          inputValues.assignedComponentCode === 145))) &&
                        userRoleOptions.findIndex((userRole) =>
                          (role.name.includes(userRole.value) &&
                            role.name.includes(inputValues.assignedComponentShortName)
                          ) ||
                          (role.owners[0].includes(userRole.value) &&
                            role.owners[0].includes(inputValues.assignedComponentShortName)
                          )
                        ) !== -1
                    }



                    return (currentSquadrons.includes(formattedSquadron) && canSeeRole) ||
                      canSeeOwners
                  })
                  .map((role) => role.name)
              }
              break
            default:
              filteredServerRoles = serverRoles
                .filter((role) => {
                  let canSeeRole = true
                  const formattedSquadron = role.name.split(' ')[0] + ' MPF'

                  if (roleContext.isMPFOwner) {
                    if (
                      role.name.includes('Technician') ||
                      role.name.includes('Section Chief') ||
                      role.name.includes('Supervisor')
                    ) {
                      canSeeRole = false
                    }
                  }

                  return (
                    role.name.includes(`-${inputValues.section}-`) &&
                    currentSquadrons.includes(formattedSquadron) &&
                    canSeeRole
                  )
                })
                .map((role) => role.name)
              break
          }
        }

        setRolesToAdd(filteredServerRoles)
        setFilteredRoles(filteredServerRoles)
      })
  }, [formattedUsers, pascodeMetadata, inputValues])

  const formatUsers = (users) => {
    const userRoleObj = {}
    users.forEach((user) => {
      user.roles.forEach((role) => {
        if (userRoleObj[role]) {
          userRoleObj[role].push(`${user.firstName} ${user.lastName}`)
        } else {
          if (
            role?.toLowerCase() !== 'user' &&
            role?.toLowerCase() !== 'appuser' &&
            role?.toLowerCase() !== 'admin'
          )
            userRoleObj[role] = [`${user.firstName} ${user.lastName}`]
        }
      })
    })
    setFormattedUsers(userRoleObj)
  }

  const changeUser = async (value: string) => {
    setSearchError(false)
    setSearchedUserToggle(false)
    setSearchedUser(value)

    if (value.trim().length > 2) {
      const userList = [...(await mpfWhoHttp().Picker(value.trim()))]
      const userName = userList.map((item) => item.persona)
      setPeopleDropdownNames(userName)
      setPeopleExpand(userList)
      if (selectedValue.title !== value) {
        setSelectedValue({ id: '', mailId: '', roles: [], title: '' })
      }
    }
  }

  const selectedUser = async (value: string) => {
    setSearchedUser(value)
    const user: IPickerModel = peopleExpand.find((item) => item.persona === value)
    const id = user.rid
    const mail = user.email
    const userRoles = await mpfAuthCrudHttp().GetUser(user.rid)
    const filteredUserRoles = userRoles?.roles.filter(
      (role) => role !== 'User' && role !== 'AppUser' && role !== 'Admin'
    )
    setSelectedValue({
      id: id,
      mailId: mail,
      roles: filteredUserRoles,
      title: value,
    })
  }

  const handleUserSearch = async (e) => {
    setSearchedUserToggle(true)
    setSearchError(!selectedValue.id)
  }

  /** *** Responsive Popup Code Start*****/
  const onChangeUserRole = (value: any) => {
    setActionbtnshowhide({
      removeuser: false,
      usersearch: false,
    })
    setShowActionPopups({
      removeuser: false,
      usersearch: false,
    })

    setInputValues((prev) => ({
      ...prev,
      majcom: value === 'Component Owner' ? '' : prev.majcom,
      section: value
    }))
  }

  const onChangeMAJCOM = (value: any) => {
    setActionbtnshowhide({
      removeuser: false,
      usersearch: false,
    })
    setShowActionPopups({
      removeuser: false,
      usersearch: false,
    })
    setInputValues((prev) => ({
      ...prev,
      majcom: value,
      section: roleContext.isSectionOwner ? prev.section : ''
    }))
  }

  const onChangeAssignedComponent = ({ label, obj, value }) => {
    setActionbtnshowhide({
      removeuser: false,
      usersearch: false,
    })
    setShowActionPopups({
      removeuser: false,
      usersearch: false,
    })

    const options = [
      ...pascodeMetadata
        .filter(
          (pascodeEntry: any) =>
            pascodeEntry.AssignedComponentCode === value && pascodeEntry.ServicingMAJCOM !== null
        )
        .map((majcomEntry: any) => ({
          label: majcomEntry.ServicingMAJCOM,
          value: majcomEntry.ServicingMAJCOM,
        })),
    ]

    const filteredMajcomOpt = options.filter((opt) => {
      return opt.label !== null && filterOptions?.majcom?.includes(opt.label)
    })

    const formattedMajcomOpts: any[] = [
      ...Object.values(
        filteredMajcomOpt.reduce(
          (acc, majObj) => ({
            ...acc,
            [majObj.value]: majObj,
          }),
          {}
        )
      ),
    ]

    if (formattedMajcomOpts.length > 1) formattedMajcomOpts.unshift({ label: ALL_SELECT_LABEL, value: '' })

    setMajcomOptions(formattedMajcomOpts)

    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: value,
      assignedComponentShortName: obj?.AbbrValue || '',
      majcom: formattedMajcomOpts[0]?.value || '',
      section: roleContext.isSectionOwner ? prev.section : '',
      squadron: '',
    }))
  }

  return (
    <div className='container'>
      <div className='row'>
        <div className='shadow card mt-0 p-0 tabscontent-height usergroups'>
          <div className='d-flex w-100 p-relative align-items-center p-3 pb-1 flex-wrap'>
            <h2
              aria-label='Filter By'
              className='d-flex align-items-center title-color17 poppins-bold font-14 me-1'
              tabIndex={0}
            >
              <span className='icon-filter font-16 pe-1'></span> Filter By:
            </h2>
            <div className='d-flex align-items-end flex-wrap settingsfilters'>
              <div className='d-flex align-items-center ms-1 my-sm-2 assigncomponentselect'>
                <CustomSelect
                  className='form-lg w-100 max-w-sm-150 min-w-sm-150  sourcesanspro font-13 customselect'
                  formClassName='form-horizontal poppins-semibold font-11 title-color41 '
                  id='AssignComponent/Organization'
                  label='Assigned Component/Organization'
                  name='Assigned Component/Organization'
                  onChange={onChangeAssignedComponent}
                  options={assignedComponentOptions}
                  value={inputValues.assignedComponentCode}
                />
              </div>
              <div className='d-flex align-items-center ms-1 my-sm-2 servicingselect'>
                <CustomSelect
                  className='form-lg w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                  disabled={inputValues.assignedComponentCode === -1}
                  formClassName='form-horizontal  poppins-semibold font-11 title-color41 '
                  id='ServicingMAJCOM'
                  label='Servicing MAJCOM'
                  name='Servicing MAJCOM'
                  onChange={(e) => onChangeMAJCOM(e.value)}
                  options={
                    inputValues.assignedComponentCode === -1
                      ? [{ label: 'None', value: '' }]
                      : majcomOptions
                  }
                  value={inputValues.majcom}
                />
              </div>
              <div className='d-flex align-items-center ms-1 my-sm-2 useroleselect'>
                <CustomSelect
                  className='form-lg w-100 max-w-sm-100 min-w-sm-100 sourcesanspro font-13 customselect'
                  disabled={inputValues.assignedComponentCode === -1}
                  formClassName='form-horizontal poppins-semibold font-11 title-color41 '
                  id='UserRoles'
                  label='User Roles'
                  name='User Roles'
                  onChange={(e) => onChangeUserRole(e.value)}
                  options={
                    inputValues.assignedComponentCode === -1
                      ? [{ label: 'None', value: '' }]
                      : userRoleOptions
                  }
                  value={inputValues.section}
                />
              </div>
              <div className='d-flex align-items-center ms-1 my-sm-2 form-horizontal me-sm-2 p-relative'>
                <div aria-labelledby='checkuserpermissions' className='me-1 font-12 poppins-medium title-color'>
                  Check user permissions:{' '}
                </div>
                <div className='d-flex align-items-center min-w-220 min-w-md-300 sppeoplepicker '>
                  <div>
                    <InputText
                      aria-label='Enter Name or Email Address'
                      changeHandler={(e: any) => changeUser(e.target.value)}
                      className='form-lg'
                      data={peopleDropdownNames}
                      formClassName=' d-flex flex-column p-relative customautocomplete'
                      infoClassName='tool-tip tooltip-bottom font-12 sourcesanspro'
                      infoIcon='icon-info color-primary'
                      inputProps={{
                        className: 'poppins-medium font-12 title-color2 mb-1',
                        id: 'checkuserpermissions',
                        maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                        placeholder: 'Enter Name or Email Address'
                      }}
                      isInfo
                      isMandatory
                      onSelect={selectedUser}
                      type='peopel-picker'
                      value={searchedUser}
                    />
                    {searchedUserToggle &&
                      (selectedValue.id ? (
                        <ul
                          style={{
                            borderRadius: '3px',
                            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                            fontSize: '90%',
                            height: 'auto',
                            maxHeight: '20em',
                            overflow: 'auto',
                            padding: '2px 0',
                            width: '80%',
                            zIndex: 100,
                          }}
                        >
                          <li
                            style={{
                              borderBottom: '3px',
                              display: 'flex',
                              fontSize: '14px',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div>User Roles</div>
                            <div
                              onClick={() => {
                                setSearchedUserToggle(false)
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              X
                            </div>
                          </li>
                          {selectedValue.roles.length > 0 ? selectedValue.roles.map((role) => (
                            <li key={role}>{role}</li>
                          )) :
                            <li
                              aria-label={NORESULT}
                              className='subtitle-color2 montserratregular'
                              style={{ padding: '1rem', textAlign: 'center', width: '100%' }}
                              tabIndex={0}
                            >
                              {NORESULT}
                            </li>
                          }
                        </ul>
                      ) : (
                        searchError && <span className='errormsg p-absolute'>Please Select a User.</span>
                      ))}
                    {peopleDropdownNames && peopleDropdownNames.length <= 0 &&
                      searchedUser.length > 2 && !searchError && (
                        <span className='errormsg p-absolute'>{'No matching user found!'}</span>
                      )}
                  </div>
                  <Buttons
                    className='border-radius03 py-1 px-2 btn-bgcolor9 ms-2 whitetext poppins-medium font-0 font-xl-13 btn-xs'
                    icon='icon-search font-11 me-xl-1'
                    label='Search'
                    onClick={(e) => handleUserSearch(e)}
                    type='button'
                  />
                </div>
              </div>
              <AddRemoveUser
                btnActionshowhide={btnActionshowhide}
                fetchUsers={fetchUsers}
                inputValues={inputValues}
                isMenusExpanded={props?.isMenusExpanded}
                rolesToAdd={rolesToAdd}
                setActionbtnshowhide={setActionbtnshowhide}
                setRolesToAdd={setRolesToAdd}
                setShowActionPopups={setShowActionPopups}
                showActionPopups={showActionPopups}
              />
            </div>
          </div>
          <div className='card-body px-0 pb-0 overflow-hidden'>
            <table className='table-bordered usertable'>
              <tr>
                <th
                  aria-label='User Roles'
                  className='bgcolor-36 whitetext col-md-5 col-lg-4 min-w-150 border-radius0  poppins-medium font-14'
                  tabIndex={0}
                >
                  User Roles
                </th>
                <th
                  aria-label='User Information'
                  className='bgcolor-36 whitetext col-md-7 col-lg-8 border-radius0 poppins-medium font-14'
                  tabIndex={0}
                >
                  User Information
                </th>
              </tr>
              {filteredRoles.map((role) => (
                <tr key={role}>
                  <th>
                    <span aria-label={role} className='maxfitcontent' tabIndex={0}>
                      {role} ({twoDigits(filteredUsers[role] ? filteredUsers[role].length : 0)})
                    </span>
                  </th>
                  <td>
                    <ul className='d-flex list-type-none flex-wrap'>
                      {filteredUsers[role] &&
                        filteredUsers[role].map((userInfo) => (
                          <li
                            aria-label={userInfo}
                            className='listdots dots-color3 mx-2 my-1 ps-4 pe-2 py-1 border-radius3 bgcolor-12 p-relative sourcesanspro font-15 title-color'
                            key={userInfo}
                            tabIndex={0}
                          >
                            {userInfo}
                          </li>
                        ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
      {showPageOverlay && <PageOverlayBusy />}
    </div>
  )
}
export default UserManagement
